import React from "react";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { CustomSelect } from "./Constants";
import { Chip } from "@mui/material";

const SingleDropdown = ({
  options,
  optionSelected,
  selectedOption,
  className,
  placement = "bottom", // default to bottom
}) => {
  const handleChange = (event) => {
    optionSelected(event.target.value);
  };

  return (
    <Select
      value={selectedOption || ""}
      onChange={handleChange}
      displayEmpty
      fullWidth
      className={className}
      input={<CustomSelect />}
      {...(placement === "top" && {
        MenuProps: {
          anchorOrigin: {
            vertical: "top",
            horizontal: "left",
          },
          transformOrigin: {
            vertical: "bottom",
            horizontal: "left",
          },
          getContentAnchorEl: null,
          PaperProps: {
            style: {
              marginTop: 0,
            },
          },
        },
      })}
    >
      {options.map((option, index) => (
        <MenuItem
          key={index}
          value={option.value}
          sx={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: "12px" }}
        >
          {placement !== "top" ? (
            option.label
          ) : (
            <Chip
              label={option.label}
              sx={{
                fontFamily: "'Space Grotesk', sans-serif",
                fontSize: "17px",
                color: option.color,
                backgroundColor: option.backgroundColor,
                height: "25px",
              }}
            />
          )}
        </MenuItem>
      ))}
    </Select>
  );
};

export default SingleDropdown;
